import Home from '../components/Home/Home';
import Layout from '../components/Layout/Layout';
// import ProductThumb from '../components/Products/ProductThumb';
const HomePage = () => {

 return (
    <Layout>
    <Home />
    </Layout>
  );
};

export default HomePage;
